// lazy-loaded module for Framer Motion's LazyMotion
import { domMax } from 'framer-motion'
export default domMax
